/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetUserRequestByExternalIDResponse } from '../../entities/v1/GetUserRequestByExternalIDResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1ExtendedUserRequestModelSchema } from './extendedUserRequestModelSchema'
import { v1FormModelSchema } from './formModelSchema'
import { v1TransportModelSchema } from './transportModelSchema'
import { z } from 'zod'

export const v1GetUserRequestByExternalIDResponseSchema = z.object({
  forms: z.array(z.lazy(() => v1FormModelSchema)),
  transport: z.lazy(() => v1TransportModelSchema),
  user_request: z.lazy(() => v1ExtendedUserRequestModelSchema),
}) as unknown as ToZod<V1GetUserRequestByExternalIDResponse>